import Image from 'next/image'
import { cn } from '@utils/utils'
import styles from './SearchComponent.module.scss'
import { SEARCH } from '../constants/icons'

interface SearchTriggerProps {
  onClick: () => void
  className?: string
}

const SearchTrigger = ({ onClick, className }: SearchTriggerProps) => (
  <div className={cn(styles.searchTrigger, className)} onClick={onClick}>
    <Image src={SEARCH} alt="Search" width={24} height={24} loading="lazy" />
    <span>What are you looking for?</span>
  </div>
)

export default SearchTrigger
